export const KEY_CODE = {
  Function: {
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
  },
  Arrow: {
    UP: 38,
    DOWN: 40,
  },
  ENTER: 13,
}
